import { lazy } from 'react';

export const StShopifyPage = lazy(() => import('./page-list'));

